import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const planIncrementEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-plan-increment-entrypoint" */ './index'),
	),
	getPreloadProps: () => ({}),
});
